import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const tipoNotificacionService = {
  getAll,
  deleteAreaNotificacionByIdAndIdArea,
  guardarTipoNotificacion,
  deleteById,
}

async function getAll() {
  return await ApiBudgety.get('TipoNotificacion/GetAll/')
}

async function deleteAreaNotificacionByIdAndIdArea(idTipoNotificacion, idArea) {
  return await ApiBudgety.post('TipoNotificacion/DeleteAreaNotificacionByIdAndIdArea/' + idTipoNotificacion + '/' + idArea)
}

async function guardarTipoNotificacion(tipoNotificacion) {
  return await ApiBudgety.post('TipoNotificacion/InsertOrUpdate/', tipoNotificacion, {
    headers: {
      ACCION: MenusSistema.configuracion_notificacion.accesos.crear_editar_tipo_notificacion,
      MENU: MenusSistema.configuracion_notificacion.id,
    },
  })
}

async function deleteById(id) {
  return await ApiBudgety.post('TipoNotificacion/Delete/' + id, null, {
    headers: {
      ACCION: MenusSistema.configuracion_notificacion.accesos.remover_tipo_notificacion,
      MENU: MenusSistema.configuracion_notificacion.id,
    },
  })
}
